// extracted by mini-css-extract-plugin
export var readonly = "_fv-1";
export var star = "_fv-0";